export const rewards = {};
